<template>
  <div class="size-container">
    <h5>{{ trans.get('wizard.chooseSize') }}</h5>
    <div class="size-container__row">
      <div
        v-for="size in this.sizes"
        v-bind:key="size.id"
        class="size-container__item"
        :class="{ selected: checkitemSelected(size) }"
        @click="selectItem(size)"
      >
        <span  class="font-bold">{{ size.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "../../mixin";
import { orderArrayPacks } from "../../utils";

export default {
  mixins: [mixin],
  props: ["sizes"],
  data: function () {
    return {
      itemSelected: {},
    };
  },
  methods: {
    selectItem(size) {
      if (size) {
        this.itemSelected = size;
        this.$emit("item-selected", size);
      }
    },
    checkitemSelected(item) {
      return this.itemSelected.id == item.id;
    },
  },
  created() {
    this.selectItem(this.sizes[0]);
  },
};
</script>

<style lang="scss" scoped>
.size-container {
  padding: 16px 0 24px 0;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #90abaa;

  &__row {
    margin-top: 1rem;
    display: flex;
    @media (max-width: 500px) {
      flex-wrap: wrap;
    }
  }

  &__item {

    height: 46px;
    width: 100%;
    margin-right: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 2px solid #90abaa;
    border-radius: 6px;
    color: black;
    background-color: white;
    cursor: pointer;

    &:hover {
      border-color: black;
    }
    &:last-child {
      margin-right: 0;
    }

    @media (max-width: 500px) {
      margin: 0.75rem 0;
      max-width: 100%;
    }

    &.selected {
      background-color: black;
      color: white;
      border-color: black;
    }
  }
}
</style>
